import { Category, CategoryTable } from "@/types/facility/category";
import { ApiResponse } from "@/types";

import { apiSlice } from "@/redux/apiSlice";

export const FacilityCategory = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getCategory: builder.query<CategoryTable, { query: string, org_id: number }>({
        query: ({ query, org_id }) => ({
          url: `/facility/category?org_id=${org_id}${query?.length > 0 ? `&${query}` : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["FacilityCategory", "Facility"],
      }),
      getCategoryById: builder.query<
        Category,
        { query: string; category_id: number }
      >({
        query: ({ category_id, query }) => ({
          url: `/facility/category/${category_id}${query?.length > 0 ? `?${query}` : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["FacilityCategory", "Facility"],
      }),
      createCategory: builder.mutation<ApiResponse, Category>({
        query: (data) => ({
          url: `/facility/category`,
          method: "POST",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["FacilityCategory", "Facility"],
      }),
      updateCategory: builder.mutation<ApiResponse, Category>({
        query: ({ id, name, parent_category_id }) => ({
          url: `/facility/category/${id}`,
          method: "PUT",
          body: { name: name },
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["FacilityCategory", "Facility"],
      }),
      deleteCategory: builder.mutation<ApiResponse, number>({
        query: (id) => ({
          url: `/facility/category/${id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["FacilityCategory", "Facility"],
      }),
    };
  },
});

export const {
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetCategoryQuery,
  useGetCategoryByIdQuery,
} = FacilityCategory;
